import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14132568"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "select-mandatory-fields" }
const _hoisted_2 = { class: "q-px-lg q-mb-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_mandatory_field_edition = _resolveComponent("mandatory-field-edition")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_toolbar, _normalizeProps(_guardReactiveProps(_ctx.TEXT_QUATERNARY_TITLE)), {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t(`LEAD_CREATION_STEPS.STEP-${_ctx.step}`, { lead: _ctx.t('LEAD.LOW.SING') })), 1)
      ]),
      _: 1
    }, 16),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_mandatory_field_edition, {
        "mandatory-config-id-list": _ctx.mandatoryConfigIdList,
        "layout-ids": _ctx.layoutIds,
        onCompleteUpdate: _ctx.completeUpdate,
        onInfogroupDataUpdate: _ctx.infoGroupDataUpdate
      }, null, 8, ["mandatory-config-id-list", "layout-ids", "onCompleteUpdate", "onInfogroupDataUpdate"])
    ])
  ]))
}